import { useState } from "react";
import { Dialog, LinearProgress } from '@mui/material';

import config from '../../utils/config';
import { DialogButton, DialogButtons, StyledDialogTitle } from '../ErrorDialog/ErrorDialog';
import './Login.css';


function Login() {
    const [isAuthenticating, setIsAuthenticating] = useState(false);

    const handleSignIn = () => {
        setIsAuthenticating(true);
    
        const client = 'smartlogs';
        const state = `smart_logs-${crypto.randomUUID()}`;

        localStorage.setItem('state', state);

        const data = {
          client,
          redirect_url: `${window.location.origin}/callback`,
          culture: 'EN',
          state,
        };
        const queryString = new URLSearchParams(data).toString();

        window.location.href = `${config.AUTHENTICATOR_URL}/taase/login?${queryString}`;
    };

    return (
        <Dialog
          aria-labelledby="form-dialog-title"
          disableEscapeKeyDown
          maxWidth="xs"
          onClose={handleSignIn}
          open
        >
            <StyledDialogTitle id="form-dialog-title">Sign in to Smart Logs</StyledDialogTitle>
            
            <DialogButtons>
                <DialogButton color="primary" disabled={isAuthenticating} disableRipple onClick={handleSignIn}>
                    BNPP AM SSO
                </DialogButton>
            </DialogButtons>

            {isAuthenticating && (
                <LinearProgress
                    classes={{
                        colorPrimary: 'Dialog-progress-primary',
                        barColorPrimary: 'Dialog-progress-secondary',
                    }}
                    variant="query"
                />
            )}
        </Dialog>
    );
}

export default Login;